/**
 * Stores the original window.history.pushState and window.history.replaceState functions,
 * if they've been monkey-patched by the URL Changed view trigger.
 *
 * @module
 */

var _ = require('optimizely-client-fn');
var actionTypes = require('core/constants/action_types');
var WindowEnv = require('core/env/window');

module.exports = {
  /**
   * Wait for appropriate Flux messages before capturing references to the original WindowEnv.getGlobal('history')
   * functions. This gives us time to stub WindowEnv.getGlobal('history') in our unit tests.
   */
  initialize: function() {
    this.__state = {
      originalPushState: null,
      originalReplaceState: null,
    };

    this.on(actionTypes.ENSURE_ORIGINAL_PUSHSTATE, this.__ensureOriginalPushState);
    this.on(actionTypes.ENSURE_ORIGINAL_REPLACESTATE, this.__ensureOriginalReplaceState);
  },

  /**
   * @returns {Function|null}
   */
  getOriginalPushState: function(): Function|null {
    return this.__state.originalPushState;
  },

  /**
   * @returns {Function|null}
   */
  getOriginalReplaceState: function(): Function|null {
    return this.__state.originalReplaceState;
  },

  /**
   * @private
   */
  __ensureOriginalPushState: function() {
    if (!this.__state.originalPushState) {
      this.__state.originalPushState = _.bind(WindowEnv.getGlobal('history').pushState, WindowEnv.getGlobal('history'));
    }
  },

  /**
   * @private
   */
  __ensureOriginalReplaceState: function() {
    if (!this.__state.originalReplaceState) {
      this.__state.originalReplaceState = _.bind(WindowEnv.getGlobal('history').replaceState, WindowEnv.getGlobal('history'));
    }
  },
};
